export class OrganizationReach {
  public id: string;
  public name: string;

  constructor(data: Partial<OrganizationReach> = {}) {
    this.id = data?.id ?? '';
    this.name = data?.name ?? '';
  }

  public static createFromApi(data: any = {}): OrganizationReach {
    return new OrganizationReach({
      id: data?.id ?? '',
      name: data?.name ?? data?.title ?? '',
    });
  }

  public processForApi(): Record<string, any> {
    return {
      id: this.id,
      title: this.name,
    };
  }
}
